import React from 'react'
import { useTranslation } from 'react-i18next'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import { IProductListItemNode } from '../../../modules/API/Defaults/models/productListNode'
import SproutIcon from '../../icons/IconLib/SproutIcon'

interface Props {
    items: IProductListItemNode[]
    value: IProductListItemNode | null
    onSelect: (product: IProductListItemNode | null) => void
    placeholder?: string
    disabled?: boolean
    readOnly?: boolean
    allowClear?: boolean
    clearLabel?: string
    className?: string
}

const ProductForSortingSelector: React.FC<Props> = ({
    items,
    value,
    onSelect,
    placeholder = 'בחר מוצר',
    disabled,
    readOnly,
    allowClear,
    clearLabel,
    className,
}) => {
    const [t] = useTranslation('selectors')

    return (
    <SearchableSelect<IProductListItemNode>
        items={items}
        value={value}
        onSelect={onSelect}
        getKey={(p) => String(p.ProductID)}
        getLabel={(p) => (p.ProductDesc ?? '').trim()}
        getSearchText={(p) => `${p.ProductDesc ?? ''} ${p.ProductDescEng ?? ''}`}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        allowClear={allowClear}
        clearLabel={clearLabel ?? t('selectors_clear')}
        leadingIcon={<SproutIcon />}
        className={className}
        emptyLabel='אין מוצרים מתאימים'
    />
    )
}

export default ProductForSortingSelector
